import React from 'react';
import {Button} from 'react-bootstrap';
import {useIntl} from 'react-intl';
import DataItemSelect from '../../../_common/components/DataItemSelect';
import DataItem from '../../../_common/components/DataItem';
import UnitGrid from './UnitGrid';
import {currencyListOptions} from '../../../_common/constants/options';
import {existingReceiptDataSelectStyles} from '../../../_common/styles/reactSelectStyles';
import {floatValueSign} from '../../../../../utils';
import {usePopupCreateReceiptContext} from '../../context/PopupCreateReceiptContext';

interface CreateReceiptFormProps {
  closeModal: () => void,
}

const CreateReceiptForm = ({
                             closeModal
                           }: CreateReceiptFormProps) => {
  const {formatMessage} = useIntl();
  const prefix = 'bankStatements-matchedInvoices-popup';
  const {isValid, createReceipt, resetForm, invoiceID} = usePopupCreateReceiptContext();

  const commonContainerStyle = 'd-flex justify-content-between px-2';
  const commonSideLabelStyle = 'text-nowrap font-size-lg custom-brand-color mr-2';

  return (
    <>
      <h3 className="card-title font-weight-bold text-dark text-center mb-4">
        {[
          formatMessage({id: `${prefix}-receipts-header`, defaultMessage: 'Receipt for invoice'}),
          invoiceID
        ].filter(Boolean).join(' ')}
      </h3>
      <div className="position-relative">
        <div className="d-flex mx-auto justify-content-between px-8 my-8">
          <DataItemSelect
            fieldId={'currencyID'}
            placeholder={'בחירה...'}
            options={currencyListOptions}
            customStyles={existingReceiptDataSelectStyles}
            containerStyle={commonContainerStyle}
            labelStyle={commonSideLabelStyle}
            inputContainerStyle={'w-150px'}
            // @ts-ignore
            label={
              <div className={'position-relative'}>
                <span className={'mandatoryMark'}>*</span>
                {formatMessage({id: `${prefix}-receipts-popup-currency`, defaultMessage: 'Currency'})}
              </div>
            }
          />
          <DataItem
            fieldId={'exchangeRate'}
            onChange={floatValueSign}
            containerStyle={commonContainerStyle}
            sideLabelStyle={commonSideLabelStyle}
            inputContainerStyle={'w-150px'}
            sideLabel={
              <div className={'position-relative'}>
                <span className={'mandatoryMark'}>*</span>
                {formatMessage({id: `${prefix}-receipts-popup-exchange-rate`, defaultMessage: 'Exchange rate'})}
              </div>
            }
          />
          <DataItem
            fieldId={'comment'}
            sideLabel={formatMessage({id: `${prefix}-receipts-popup-existing-comment`, defaultMessage: 'Comment'})}
            containerStyle={commonContainerStyle}
            sideLabelStyle={commonSideLabelStyle}
            inputContainerStyle={'w-500px'}
          />
        </div>
        <UnitGrid/>
      </div>
      <div className="d-flex justify-content-center mt-8">
        <Button
          type={'button'}
          className="btn btn-secondary btn-sm col-2 mx-3 "
          onClick={async () => {
            resetForm();
            closeModal();
          }}
        >
          {formatMessage({id: 'label-button-cancel', defaultMessage: 'Cancel'})}
        </Button>
        <Button
          className="btn btn-icon btn-sm col-2 mx-3 custom-send-button"
          type="submit"
          disabled={!isValid}
          onClick={async () => {
            await createReceipt();
            resetForm();
            closeModal();
          }}
        >
          {formatMessage({id: 'label-button-send', defaultMessage: 'Send'})}
        </Button>
      </div>
    </>
  );
};

export default CreateReceiptForm;
